module.exports = __webpack_public_path__ + "bd009522d014f701a0477b8174ce39ec.pdf";